module.exports = __webpack_public_path__ + "static/media/logo-edulab.8dbeac89.png";